import React from 'react';

const PrivacyPage = () => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
    <h1 className="font-heading font-bold text-3xl text-white mb-8">Privacy Policy</h1>
    <div className="max-w-none space-y-6 text-slate-400">
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">1. Information We Collect</h2>
        <p>
          We collect information you provide: email, name, profile details, photos (if you upload them),
          and messages sent on the Platform. We also collect usage data (e.g. device, IP) for security
          and improving the service. Payment data is processed by Razorpay; we do not store full card
          details.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">2. How We Use It</h2>
        <p>
          We use your information to run the Platform, process payments, verify accounts, enforce
          our Terms, and communicate with you. We do not sell your personal data to third parties
          for marketing.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">3. Who Sees Your Data</h2>
        <p>
          Other users see only what you choose to show on your profile (e.g. display name, bio, photos).
          We may share data with law enforcement when required by law or to protect safety. Our
          service providers (e.g. hosting, payments) process data on our behalf under strict agreements.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">4. Security</h2>
        <p>
          We use industry-standard measures to protect your data (encryption, access controls).
          You are responsible for keeping your password secure and logging out on shared devices.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">5. Your Rights</h2>
        <p>
          You can access, correct, or delete your profile data from Settings. You may request a copy
          of your data or ask us to stop certain processing where applicable by law. Contact us via
          the Contact page.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">6. Retention</h2>
        <p>
          We retain your data while your account is active and as needed for legal or safety purposes
          after closure.
        </p>
      </section>
      <section>
        <h2 className="font-heading font-bold text-xl text-white mt-6 mb-2">7. Updates</h2>
        <p>
          We may update this Privacy Policy. Changes will be posted here. Continued use constitutes
          acceptance.
        </p>
      </section>
    </div>
  </div>
);

export default PrivacyPage;
